import Image from 'next/image';
import type { FC } from 'react';
import { Box, Button } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
const ContactSocialMedia: FC = () => {
  return <div className="order-1  w-full md:w-[calc(50%-1rem)] xl:w-[calc(50%-1.5rem)]" data-sentry-component="ContactSocialMedia" data-sentry-source-file="contactSocialMedia.tsx">
      <Box color="secondary" className="flex h-full  justify-between border-4 border-blueFour bg-grade-description bg-contain bg-right-bottom bg-no-repeat p-5 sm:p-6" data-sentry-element="Box" data-sentry-source-file="contactSocialMedia.tsx">
        <div className="flex  w-full items-center justify-between gap-4 sm:gap-4">
          <div className="flex min-h-[121px] min-w-[126px]">
            <Image src={`${FILE_BROWSER_URL}/img/img-insta-logo.svg`} loading="lazy" alt="اینستاگرام " width={126} height={121} data-sentry-element="Image" data-sentry-source-file="contactSocialMedia.tsx" />
          </div>
          <div className="flex w-full flex-col bg-blueFour p-2 md:mb-0 md:p-4 ">
            <span className="leading-2 mb-2 mt-3 text-right font-pelak text-sm font-bold text-blueOne   ">
              شبکه‌های اجتماعی:
            </span>

            <div className="flex justify-evenly ">
              <Button as="a" href="https://ble.ir/ino_school" target="_blank" size="small" variant="contained" color="secondaryLight" className="!px-2" radius="round" data-sentry-element="Button" data-sentry-source-file="contactSocialMedia.tsx">
                <Image src={`${FILE_BROWSER_URL}/img/bale.webp`} alt="bale" width={24} height={24} data-sentry-element="Image" data-sentry-source-file="contactSocialMedia.tsx" />
              </Button>
              <div className="mx-2">
                <Button as="a" href="https://t.me/ino_school" target="_blank" size="small" variant="contained" color="secondaryLight" className="!px-2" radius="round" data-sentry-element="Button" data-sentry-source-file="contactSocialMedia.tsx">
                  <Image src={`${FILE_BROWSER_URL}/img/telegram.webp`} alt="telegram" width={24} height={24} data-sentry-element="Image" data-sentry-source-file="contactSocialMedia.tsx" />
                </Button>
              </div>
              <Button as="a" href="https://rubika.ir/ino_school" target="_blank" size="small" variant="contained" color="secondaryLight" className="!px-2" radius="round" data-sentry-element="Button" data-sentry-source-file="contactSocialMedia.tsx">
                <Image width={25} height={25} src={`${FILE_BROWSER_URL}/img/rubika.webp`} alt="rubika" data-sentry-element="Image" data-sentry-source-file="contactSocialMedia.tsx" />
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </div>;
};
export default ContactSocialMedia;